import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const userSubscriptionCacheKey = 'userSubscription';
export const userSubscriptionDocument = /* GraphQL */ `
    query GetUserSubscription {
        userSubscription {
            activeCoupons {
                couponCode
                discountType
                discountPercent
                balanceInCents
                duration
                temporalUnit
                temporalAmount
                freeTrialUnit
                freeTrialAmount
                discount {
                    type
                    percent
                    currencies {
                        currency
                        amount
                    }
                    trial
                }
            }
            subscription {
                uuid
                planName
                planCode
                unitAmountInCents
                currency
                activatedAt
                canceledAt
                expiresAt
                currentPeriodEndsAt
                addOns
                pendingSubscription
            }
        }
    }
`;

export const userSubscriptionQuery = graphql(userSubscriptionDocument);
